/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OsisRuleCreateRequest,
    OsisRuleCreateRequestFromJSON,
    OsisRuleCreateRequestToJSON,
    OsisRuleFormConfiguration,
    OsisRuleFormConfigurationFromJSON,
    OsisRuleFormConfigurationToJSON,
    OsisRuleFormData,
    OsisRuleFormDataFromJSON,
    OsisRuleFormDataToJSON,
    OsisRuleFormDataBase,
    OsisRuleFormDataBaseFromJSON,
    OsisRuleFormDataBaseToJSON,
    OsisRuleUpdateRequest,
    OsisRuleUpdateRequestFromJSON,
    OsisRuleUpdateRequestToJSON,
    OsisRuleValidationData,
    OsisRuleValidationDataFromJSON,
    OsisRuleValidationDataToJSON,
} from '../models';

export interface ApiBookingCreateManagerOsisV2OsisRuleFormCreatePostRequest {
    osisRuleCreateRequest?: OsisRuleCreateRequest;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleFormDeleteDeleteRequest {
    id?: string;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleFormUpdatePostRequest {
    osisRuleUpdateRequest?: OsisRuleUpdateRequest;
}

export interface ApiBookingCreateManagerOsisV2OsisRuleFormValidatePostRequest {
    osisRuleFormDataBase?: OsisRuleFormDataBase;
}

/**
 * no description
 */
export class OsisRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormConfigurationGetRaw(): Promise<runtime.ApiResponse<OsisRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OsisRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormConfigurationGet(): Promise<OsisRuleFormConfiguration> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormCreatePostRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormCreatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OsisRuleCreateRequestToJSON(requestParameters.osisRuleCreateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormCreatePost(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormCreatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerOsisV2OsisRuleFormCreatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormDeleteDeleteRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleForm/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormDeleteDelete(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormDeleteDeleteRequest): Promise<void> {
        await this.apiBookingCreateManagerOsisV2OsisRuleFormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormGetByIdGetRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<OsisRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OsisRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormGetByIdGet(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormGetByIdGetRequest): Promise<OsisRuleFormData> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormUpdatePostRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OsisRuleUpdateRequestToJSON(requestParameters.osisRuleUpdateRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormUpdatePost(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormUpdatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerOsisV2OsisRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormValidatePostRaw(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormValidatePostRequest): Promise<runtime.ApiResponse<OsisRuleValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/OsisV2/OsisRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OsisRuleFormDataBaseToJSON(requestParameters.osisRuleFormDataBase),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OsisRuleValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerOsisV2OsisRuleFormValidatePost(requestParameters: ApiBookingCreateManagerOsisV2OsisRuleFormValidatePostRequest): Promise<OsisRuleValidationData> {
        const response = await this.apiBookingCreateManagerOsisV2OsisRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
